export const fetchAgendaItemVotesForMeeting = async ($http, meetingId) => {
  const response = await $http.get(
    `/v2/gm/general-meetings/${meetingId}/agenda-votes`
  );
  return response.data;
};
